import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const flowRestClient = new RestClient(atmoClient, "flows");
